import I18n from 'I18n';
import { useState } from 'react';
import * as React from 'react';
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import TimelineItemStepLabel from 'flow-doctor-lib/components/timeline/labels/TimelineItemStepLabel';
import { TIMESTAMP_DATE_FORMAT, TIMESTAMP_TIME_FORMAT } from 'flow-doctor-lib/constants/Global';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from 'flow-doctor-lib/usageTracker';
import FlowDoctorHandlerContext from 'flow-doctor-lib/context/FlowDoctorHandlerContext';
import { doesTimelineItemHaveLargeDrift, getTimelineItemTimestamp } from 'flow-doctor-lib/utils/timelineItemUtils';
import { WarningIcon } from 'foundations-assets';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIFlex = styled.div.withConfig({
  displayName: "EnrollmentTimelineDisplayRow__StyledUIFlex",
  componentId: "kl4mjr-0"
})(({
  theme,
  focused
}) => `
  display: flex;
  justify-content: space-between;
  border-radius: 2px;
  border: none;
  background-color: ${focused ? theme.color['fill-accent-yellow-subtle'] : 'initial'};
`);
const StyledText = styled.div.withConfig({
  displayName: "EnrollmentTimelineDisplayRow__StyledText",
  componentId: "kl4mjr-1"
})(["min-height:60px;"]);
const DateTimeDisplay = styled.div.withConfig({
  displayName: "EnrollmentTimelineDisplayRow__DateTimeDisplay",
  componentId: "kl4mjr-2"
})(({
  theme
}) => `
  position: absolute;
  left: ${theme.space['0']};
  top: ${theme.space['50']};
  padding-right: ${theme.space['200']};
  transform: translateX(-100%);
  width: fit-content;

  display: flex;
  align-items: center;
  gap: ${theme.space['100']};
`);
const StyledTimelineItemStepLabel = styled.div.withConfig({
  displayName: "EnrollmentTimelineDisplayRow__StyledTimelineItemStepLabel",
  componentId: "kl4mjr-3"
})(({
  theme
}) => `
  text-transform: initial;
  margin-top: ${theme.space['50']};
  margin-left: ${theme.space['50']};
`);
const EnrollmentTimelineDisplayRow = ({
  logItem,
  objectTypeId,
  flowId,
  focused,
  usePersistedTimestamp = false
}) => {
  const {
    onViewRevision
  } = React.useContext(FlowDoctorHandlerContext);
  const [showRevisionButton, setShowRevisionButton] = useState(false);
  const timestamp = getTimelineItemTimestamp(logItem, usePersistedTimestamp);
  const hasLargeTimestampDifference = doesTimelineItemHaveLargeDrift(logItem);
  return /*#__PURE__*/_jsxs(StyledUIFlex, {
    "data-test-id": `timeline-${logItem.type}`,
    focused: focused,
    onClick: () => {},
    onMouseEnter: () => setShowRevisionButton(true),
    onMouseLeave: () => setShowRevisionButton(false),
    children: [/*#__PURE__*/_jsxs(StyledText, {
      children: [/*#__PURE__*/_jsx(StyledTimelineItemStepLabel, {
        children: /*#__PURE__*/_jsx(TimelineItemStepLabel, {
          flowId: flowId,
          logItem: logItem,
          objectTypeId: objectTypeId
        })
      }), /*#__PURE__*/_jsxs(DateTimeDisplay, {
        children: [hasLargeTimestampDifference && /*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.largeTimestampDifference"
          }),
          children: /*#__PURE__*/_jsx(WarningIcon, {
            size: "300",
            color: "do-not-use-marigold-dark"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          children: [/*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: I18n.moment.portalTz(timestamp),
              format: TIMESTAMP_DATE_FORMAT
            })
          }), /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: I18n.moment.portalTz(timestamp),
              format: TIMESTAMP_TIME_FORMAT
            })
          })]
        })]
      })]
    }), onViewRevision && showRevisionButton && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Button, {
        size: "xs",
        use: "tertiary",
        onClick: () => {
          usageTracker.track('pageAction', {
            actionType: 'CLICK_REVISION'
          });
          onViewRevision(timestamp);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.viewRevision.button"
        })
      })
    })]
  });
};
export default EnrollmentTimelineDisplayRow;